import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { AddressButton } from '../../components_renew/Address/AddressButton'
import { requestAddressData } from '../../actions/addressAction'

let { PATH } = window

@withRouter
@connect(state => state.addressData)
class AddressEntry extends React.PureComponent {
  componentDidMount () {
    let { list, invalid } = this.props
    if (!(list.length > 0) || invalid) {
      this.props.dispatch(requestAddressData())
    }
  }

  render () {
    let { selectedAddress, loading } = this.props
    let addressId = selectedAddress ? selectedAddress['id'] : undefined
    return <AddressButton loading={loading} address={selectedAddress} addressId={addressId} onClick={this.onClick} />
  }

  onClick = () => {
    this.props.history.push(PATH.ADDRESS.LIST)
  }
}

export { AddressEntry }
